module.exports = __webpack_public_path__ + "img/mira_220l_list.be0376ca.jpg";